module.exports = __webpack_public_path__ + "img/6.37155889.png";